import { CognitoUser } from '@aws-amplify/auth';
import { Auth } from 'aws-amplify';
import { selectAuthUserInfo } from 'src/redux/auth/selectors';
import { selectNetworkState } from 'src/redux/common/selectors';
import { store } from 'src/redux/store';
import { AppLimitedMode, calculatedLimitedMode } from './useLimitedMode';

/**
 * Returns information about whether or not the app is in a "limited" state.
 * Only intended for use in contexts where hooks are not available.
 */
export const getLimitedMode = async (): Promise<AppLimitedMode | undefined> => {
  const cognitoUser: CognitoUser | null = await Auth.currentAuthenticatedUser();
  const exp = cognitoUser?.getSignInUserSession()?.getAccessToken().getExpiration();
  const isSessionExpired = exp === undefined ? true : exp * 1000 < Date.now();
  return calculatedLimitedMode(
    !!cognitoUser,
    isSessionExpired,
    selectNetworkState(store.getState()),
    !!selectAuthUserInfo(store.getState()),
  );
};
